import React, { useEffect, useState } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { GetGeneralVoucherListAtom } from "../../store/voucherAtom";
import { formatCustomDate } from "../../helpers/formatCustomDate";
import { formatCustomNumber } from "../../helpers/formatCustomNumber";

export default function VoucherScroll(props) {
  const { id } = useParams();
  const navigate = useNavigate();
  const { pathname } = useLocation();  
  var url = pathname.split('/')
  const currModuleId = url[1];
  const currModuleName = url[2];
  const currUserMenu = url[3];

  const voucherList = GetGeneralVoucherListAtom();
  const [vouchers, setVouchers] = useState([]);

  useEffect(() => {
    if (voucherList?.length) {
      setVouchers(voucherList);
    }
  }, [voucherList]);

  const handleSelect = (voucherId) => {
    props.viewVoucher(voucherId);
  };


  const onItemSelect = (id)=> {
    navigate(`/${currModuleId}/${currModuleName}/${currUserMenu}/details/${id}`);
}


  const statusBadge = (statusId, statusName) => {
    const styles = {
      1: "bg-blue-100 text-blue-800 border-blue-200",       // Draft / Pending
      2: "bg-emerald-100 text-emerald-800 border-emerald-200", // Active / Issued
      3: "bg-amber-100 text-amber-800 border-amber-200",     // Processing / Pending Approval
      4: "bg-rose-100 text-rose-800 border-rose-200",        // Expired / Rejected
      5: "bg-purple-100 text-purple-800 border-purple-200",  // Redeemed / Used
      6: "bg-gray-100 text-gray-700 border-gray-200",        // Cancelled
      7: "bg-orange-100 text-orange-800 border-orange-200",  // Partial / Processing
    };

    return (
      <span
        className={`inline-flex px-2.5 py-1 rounded-full text-xs font-medium border ${
          styles[statusId] || "bg-gray-100 text-gray-700 border-gray-200"
        }`}
      >
        {statusName || "—"}
      </span>
    );
  };

  return (
    <div className="h-screen flex overflow-hidden">
         <div className="h-full bg-white flex flex-col border-r">
      {/* Fixed Header */}
      <div className="px-5 py-4 border-b bg-gray-50">
        <h3 className="text-sm font-semibold text-gray-700 tracking-tight">
          Vouchers
          <span className="ml-1.5 text-gray-500 font-normal">
            ({vouchers.length})
          </span>
        </h3>
      </div>

      {/* Scrollable List */}
      <div className="flex-1 overflow-y-auto scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-gray-50 hover:scrollbar-thumb-gray-400 transition-colors">
        {vouchers.length === 0 ? (
          <div className="h-full flex flex-col items-center justify-center text-gray-500 text-sm px-6 text-center py-10">
            <p className="font-medium">No vouchers found</p>
            <p className="mt-1 text-gray-400">Create or import vouchers to see them here</p>
          </div>
        ) : (
          <div className="divide-y divide-gray-100">
            {vouchers.map((voucher) => {
              const isActive = Number(id) === Number(voucher?.Ref_No);

              return (
                <div
                  key={voucher.Ref_No}
                  
                  onClick={() => onItemSelect(voucher.Ref_No)}
                  className={`
                    group px-5 py-3.5 cursor-pointer transition-all duration-150
                    hover:bg-indigo-50/60
                    ${isActive 
                      ? "bg-indigo-50/80 border-l-4 border-l-indigo-500 font-medium" 
                      : "hover:border-l-4 hover:border-l-indigo-300/50"}
                  `}
                >
                  <div className="flex items-start justify-between gap-3">
                    {/* Main content */}
                    <div className="flex-1 min-w-0">
                      <div className="flex items-center justify-between">
                        <p className="text-sm font-semibold text-gray-900 truncate">
                          {voucher?.Voucher_Number || "—"}
                        </p>
                        <div className="ml-2">
                          {statusBadge(voucher?.Voucher_Status_Id, voucher?.Voucher_Status_Name)}
                        </div>
                      </div>

                      <div className="mt-1.5 flex flex-col gap-1 text-xs text-gray-600">
                        <div className="flex justify-between">
                          <span>
                            {formatCustomDate(voucher?.Transaction_Date) || "—"}
                          </span>
                          <span className="font-medium text-emerald-700">
                            ₦{formatCustomNumber(voucher?.Voucher_Amount) || "0.00"}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>

      {/* Footer count */}
      {vouchers.length > 0 && (
        <div className="px-5 py-2.5 bg-gray-50 border-t text-xs text-gray-500 flex justify-between items-center">
          <span>
            {vouchers.length} {vouchers.length === 1 ? "voucher" : "vouchers"}
          </span>
          <span className="text-gray-400">Click to view details</span>
        </div>
      )}
    </div>

    </div>
   
  );
}